import { Scrollbox as ScrollboxPrimitive, Typography } from "@packages/ds";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin-bottom: 32px;
`;

export const Header = styled.header`
  display: flex;
  margin-bottom: 16px;
`;

export const Title = styled(Typography.Title)`
  display: flex;
  flex: 1;
`;

export const Layout = styled.div`
  position: relative;
  padding: 16px 0 32px 0;
  border-radius: var(
    --box-wrapper-section-border-radius,
    var(--section-2px-border-radius, var(--2px))
  );
  background-color: var(--section-snow-background-color, var(--snow));

  @media (max-width: 768px) {
    padding: 0;
  }

  hr {
    background-color: var(
      --section-color-primary-100-background-color,
      var(--color-primary-100)
    );
    box-shadow: none;
    height: 1px;
    border: none;
    margin: 16px 0;
    &.full-width {
      margin: 0 -32px 16px;
    }
  }
  .environments-filter-window > section {
    overflow: visible;
  }
  h6 .info-dialog {
    vertical-align: middle;
  }
`;

export const Scrollbox = styled(ScrollboxPrimitive)`
  overflow-x: hidden;
`;

export const TreeWrapper = styled.div`
  padding: 16px 32px 0 32px;

  @media (max-width: 768px) {
    padding: 16px 16px 0 16px;
  }

  ol {
    margin: 0;
    padding: 0;

    & > :not(:last-child) {
      margin-bottom: 24px;
    }
  }
`;
